import script from "./FormCheckboxField.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormCheckboxField.vue?vue&type=script&setup=true&lang=ts"

import "./FormCheckboxField.vue?vue&type=style&index=0&id=876cbc50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876cbc50"]])

export default __exports__